import { Layout, Orientation } from '../../components/handler-components/ResizeHandler';
import { SIDE_BAR_TABS } from '../../data-types/betting/bettingEnums';
import { FadeOutOverlayData } from '../../data-types/initialisation/initialisationInterfaces';
import { SubNavItem } from '../../data-types/main-menu/mainMenuInterfaces';
import { SEARCH_TYPE } from '../../data-types/search/searchEnums';
import { SearchData } from '../../data-types/search/searchInterfaces';
import { EVENT_DETAIL_DISPLAY_TYPE } from '../../data-types/sports/sportsEnums';
import { SportsMenu } from '../../data-types/sports/sportsInterfaces';
import { ResetState } from './stateTypes';

export type NavigationActionType =
  | ResetState
  | SetProfileMenuAction
  | SetSearchType
  | SetSearchText
  | SetVerificationOverlay
  | SetDesktopProfilePath
  | SetRenderDesktopHelpOpen
  | SetPreventRedirectOnError
  | SetFadeOutOverlayData
  | SetEventDetailViewType
  | SetSelectedBetSideBarTab
  | SetSportsMenu
  | SetLayout
  | SetWidth
  | SetHeight
  | SetOrientation
  | SetSelectedSubNavItem;

export const SET_PROFILE_MENU = 'SET_PROFILE_MENU';
export const SET_SPORTS_MENU = 'SET_SPORTS_MENU';
export const SET_PROFILE_MENU_SELECTED = 'SET_PROFILE_MENU_SELECTED';
export const SET_SEARCH_TYPE = 'SET_SEARCH_TYPE';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const SET_VERIFICATION_OVERLAY = 'SET_VERIFICATION_OVERLAY';
export const SET_DESKTOP_PROFILE_PATH = 'SET_DESKTOP_PROFILE_PATH';
export const SET_DESKTOP_RENDER_HELP_OPEN = 'SET_DESKTOP_RENDER_HELP_OPEN';
export const SET_PREVENT_REDIRECT_ON_ERROR = 'SET_PREVENT_REDIRECT_ON_ERROR';
export const SET_FADE_OUT_OVERLAY_DATA = 'SET_FADE_OUT_OVERLAY_DATA';
export const SET_EVENT_DETAIL_VIEW_TYPE = 'SET_EVENT_DETAIL_VIEW_TYPE';
export const SET_SELECTED_BET_SIDE_BAR_TAB = 'SET_SELECTED_BET_SIDE_BAR_TAB';
export const SET_LAYOUT = 'SET_LAYOUT';
export const SET_WIDTH = 'SET_WIDTH';
export const SET_HEIGHT = 'SET_HEIGHT';
export const SET_ORIENTATION = 'SET_ORIENTATION';
export const SET_SELECTED_SUB_NAV_ITEM = 'SET_SELECTED_SUB_NAV_ITEM';

export interface NavigationState {
  search: SearchData;
  desktopProfilePath: string | undefined;
  renderDesktopHelpOpen: boolean;
  preventRedirectOnError: boolean;
  verificationOverlayOpen: boolean;
  fadeOutOverlay: FadeOutOverlayData;
  eventDetailDisplayType: EVENT_DETAIL_DISPLAY_TYPE;
  sportsMenu: SportsMenu;
  selectedBetSideBarTab: SIDE_BAR_TABS | undefined;
  layout: Layout;
  width: number;
  height: number;
  orientation: Orientation;
  selectedSubNavItem: SubNavItem | undefined;
}

interface SetProfileMenuAction {
  type: typeof SET_PROFILE_MENU;
  meta: {
    profileMenu: string;
  };
}

interface SetSearchText {
  type: typeof SET_SEARCH_TEXT;
  meta: string;
}

interface SetSearchType {
  type: typeof SET_SEARCH_TYPE;
  meta: SEARCH_TYPE | undefined;
}

interface SetVerificationOverlay {
  type: typeof SET_VERIFICATION_OVERLAY;
  meta: boolean;
}

interface SetDesktopProfilePath {
  type: typeof SET_DESKTOP_PROFILE_PATH;
  meta: string | undefined;
}

interface SetRenderDesktopHelpOpen {
  type: typeof SET_DESKTOP_RENDER_HELP_OPEN;
  meta: boolean;
}

interface SetPreventRedirectOnError {
  type: typeof SET_PREVENT_REDIRECT_ON_ERROR;
  meta: boolean;
}
interface SetFadeOutOverlayData {
  type: typeof SET_FADE_OUT_OVERLAY_DATA;
  meta: FadeOutOverlayData;
}

interface SetEventDetailViewType {
  type: typeof SET_EVENT_DETAIL_VIEW_TYPE;
  meta: EVENT_DETAIL_DISPLAY_TYPE;
}

interface SetSportsMenu {
  type: typeof SET_SPORTS_MENU;
  meta: SportsMenu;
}

interface SetSelectedBetSideBarTab {
  type: typeof SET_SELECTED_BET_SIDE_BAR_TAB;
  meta: SIDE_BAR_TABS | undefined;
}

interface SetLayout {
  type: typeof SET_LAYOUT;
  meta: Layout;
}

interface SetWidth {
  type: typeof SET_WIDTH;
  meta: number;
}

interface SetHeight {
  type: typeof SET_HEIGHT;
  meta: number;
}

interface SetOrientation {
  type: typeof SET_ORIENTATION;
  meta: number;
}

interface SetSelectedSubNavItem {
  type: typeof SET_SELECTED_SUB_NAV_ITEM;
  meta: SubNavItem | undefined;
}
